export const SECTION_TYPES: { [context: string]: string } = {
  SECTION: 'section',
  HEADER: 'header',
  BODY: 'body',
}

export const lookupTable: { [context: string]: string } = {
  newengland: 'BOS',
  centralatlantic: 'CAT',
  midwest: 'CHI',
  'mi-oh-ky-tn': 'CIN',
  connecticut: 'CON',
  denver: 'DVR',
  greaterny: 'GNY',
  goldcoast: 'GOC',
  gst: 'GST',
  inlandnorthwest: 'INW',
  central: 'KAC',
  norcal: 'NCA',
  phoenix: 'PHX',
  pacificnorthwest: 'PTL',
  southeasttoyota: 'SET',
  sandiego: 'SND',
  socal: 'SOC',
  tristateeast: 'TRE',
  tristate: 'TRI',
  upstateny: 'UST',
  westernwashington: 'WWN',
};

// TDA List // BOS, CAT, CHI, CIN, CON, DVR, GNY, GOC, GST, INW, KAC, NCA, PHX, PTL, SET, SND, SOC, TRE, TRI, UST, WWN
